  <rask-search
    #anvandareSearch
    aid="anvandarNamn"
    class="col-3"
    label="Visa händelser för"
    bindLabel="namn"
    typeToSearchText="Sök användarnamn"
    loadingText="Laddar..."
    notFoundText="Ingen träff"
    [minTermLength]="3"
    [typeaheadFn]="searchAnvandareTypeAhead"
    (change)="searchAnvandareTypeAheadChange(anvandareSearch.value)">
  </rask-search>